import { NgModule } from '@angular/core';

import { ThumbForHistoryOrderModule } from './forHistoryOrder';
import { ThumbForLocationModule } from './forLocation';
import { ThumbForOnlineMenuProductModule } from './forOnlineMenuProduct';
import { ThumbForOrderTypeModule } from './forOrderType';
import { ThumbForPromotionItemModule } from './forPromotionItem';
import { ThumbForRewardModule } from './forReward';
import { ThumbForTransactionModule } from './forTransaction';
import { ThumbForWizzardProductModule } from './forWizzardProduct';

const toExport: any[] = [
    ThumbForHistoryOrderModule,
    ThumbForLocationModule,
    ThumbForOnlineMenuProductModule,
    ThumbForOrderTypeModule,
    ThumbForPromotionItemModule,
    ThumbForRewardModule,
    ThumbForTransactionModule,
    ThumbForWizzardProductModule,
];

@NgModule({
    imports: [
        ...toExport
    ],
    exports: [
        ...toExport
    ],
})
export class ThumbTypesModule { }
